import React from 'react'; // useMemo
import { Form } from 'react-final-form';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import debug from 'debug';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { TextField } from '../../../lib/mui-rff/TextField';
import { composeValidators, isRequired, isValidEmail, isValidPhoneNumber, isValidMessage } from '../../../utilities/regEx';

const d = debug('recipientForm');

interface RecipientFormProps {
  initialValues?: any;
  onAddRecipient: (values: any) => void;
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    field: {
      '& .MuiInputLabel-root.Mui-error.Mui-required': {
        color: theme.palette.text.primary,
      },
      '& .MuiFormLabel-asterisk.Mui-error': {
        color: theme.palette.text.primary,
      },
      '& .MuiFormHelperText-root.Mui-error': {
        color: theme.palette.error.main,
      },
    },
    optionalFieldLabel: {
      '& .MuiInputLabel-root.Mui-error': {
        color: theme.palette.text.primary,
      },
    },
  }),
  { name: 'RecipientForm' },
);

const RecipientForm: React.FC<RecipientFormProps> = ({
  initialValues = {
    // cardMedium: 'digital',
    // recipientCount: 'multiple',
    // recipientType: 'friend',
    // recipients: [null],
  },
  onAddRecipient,
}) => {
  const classes = useStyles();
  const onValidate = async (values: any) => {
    d('validate', values);
  };
  const onSubmit = async (values: any, form: any) => {
    d('addRecipient', values, form);
    if (onAddRecipient) {
      onAddRecipient(values.newRecipient);
    }
    reset(form);
  };
  const reset = (form: any) => {
    form.change('newRecipient.name', '');
    form.change('newRecipient.email', '');
    form.change('newRecipient.phone', '');
    form.change('newRecipient.message', '');
    form.resetFieldState('newRecipient.name');
    form.resetFieldState('newRecipient.email');
    form.resetFieldState('newRecipient.phone');
    form.resetFieldState('newRecipient.message');
  };
  return (
    <Form
      initialValues={{
        newRecipient: {
          // name: 'James',
          // email: 'jt@ie.com.au',
          // message: 'Sup',
        },
      }}
      validate={onValidate}
      onSubmit={onSubmit}
      decorators={[]}
      mutators={
        {
          // ...arrayMutators,
        }
      }
    >
      {({
        handleSubmit,
        // form: {
        //   mutators: { push, pop },
        // },
        form,
        submitting,
        values,
        valid,
        pristine,
      }) => (
        <div>
          {/* <form onSubmit={handleSubmit} className={classes.form}> */}
          <Stack spacing={2}>
            <TextField
              className={classes.field}
              fieldProps={{
                validate: composeValidators(isRequired),
              }}
              fullWidth
              name={`newRecipient.name`}
              variant="standard"
              label="Recipient Name"
              required
            />
            <Stack direction="row" spacing={4}>
              <TextField
                className={classes.field}
                fieldProps={{
                  validate: composeValidators(isRequired, isValidEmail),
                }}
                fullWidth
                name={`newRecipient.email`}
                variant="standard"
                label="Recipient Email"
                required
              />
              <TextField
                className={`${classes.field} ${classes.optionalFieldLabel}`}
                fullWidth
                name={`newRecipient.phone`}
                variant="standard"
                label="Recipient Phone Number"
                type="tel"
                helperText="Send your gift card as an SMS (Optional)"
                inputProps={{ maxLength: 10 }}
                fieldProps={{
                  validate: composeValidators(isValidPhoneNumber),
                }}
              />
            </Stack>
            <TextField
              fullWidth
              name={`newRecipient.message`}
              variant="standard"
              label="Recipient Message"
              multiline
              inputProps={{ maxLength: 150 }}
              helperText="Optional"
              fieldProps={{
                validate: composeValidators(isValidMessage),
              }}
            />
          </Stack>
          <br />
          <Button disabled={!valid && pristine} variant="outlined" onClick={handleSubmit} startIcon={<AddIcon />}>
            Add recipient
          </Button>
        </div>
      )}
    </Form>
  );
};

export default RecipientForm;
